export const TASK_QUEUE_STATUS_COLOR_MAP = {
  PENDING: '#BDBDBD',
  PAUSED: '#FFA726',
  RUNNING: '#42A5F5',
  FINISHED: '#66BB6A'
}
